import { useState, useEffect } from "react";
import "../styles/CookieBanner.css";

export default function CookieBanner() {
    const [showBanner, setShowBanner] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [preferences, setPreferences] = useState({
        necessary: true,
        analytics: false,
        marketing: false
    });

    useEffect(() => {
        const saved = localStorage.getItem("cookie-consent");
        if (!saved) {
            setShowBanner(true);
        } else {
            setPreferences(JSON.parse(saved));
        }

        const handler = () => setShowModal(true);
        window.addEventListener("open-cookie-preferences", handler);

        return () => {
            window.removeEventListener("open-cookie-preferences", handler);
        };
    }, []);




    const savePreferences = (prefs) => {
        setPreferences(prefs);
        localStorage.setItem("cookie-consent", JSON.stringify(prefs));
        setShowBanner(false);
        setShowModal(false);
    };

    return (
        <>
            {showBanner && (
                <div className="cookie-banner">
                    <p>
                        Utilizziamo cookie tecnici e, previo consenso, anche analytics e marketing
                        per migliorare la tua esperienza.
                    </p>
                    <div className="actions">
                        <button onClick={() => savePreferences({ necessary: true, analytics: false, marketing: false })}>
                            Rifiuta
                        </button>
                        <button onClick={() => setShowModal(true)}>
                            Personalizza
                        </button>
                        <button onClick={() => savePreferences({ necessary: true, analytics: true, marketing: true })}>
                            Accetta tutti
                        </button>
                    </div>
                </div>
            )}

            {showModal && (
                <div className="cookie-modal">
                    <div className="cookie-modal-content">
                        <h2>Preferenze Cookie</h2>
                        <p>Seleziona le categorie di cookie da abilitare:</p>

                        <label>
                            <input type="checkbox" checked disabled />
                            Necessari (sempre attivi)
                        </label>

                        <label>
                            <input
                                type="checkbox"
                                checked={preferences.analytics}
                                onChange={(e) =>
                                    setPreferences({ ...preferences, analytics: e.target.checked })
                                }
                            />
                            Analytics
                        </label>

                        <label>
                            <input
                                type="checkbox"
                                checked={preferences.marketing}
                                onChange={(e) =>
                                    setPreferences({ ...preferences, marketing: e.target.checked })
                                }
                            />
                            Marketing
                        </label>

                        <div className="modal-actions">
                            <button onClick={() => savePreferences(preferences)}>Salva preferenze</button>
                            <button className="ghost" onClick={() => setShowModal(false)}>Chiudi</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
